import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as salesPipelineRoutes } from './sales_pipeline/routes';
import calendar from './calendar/calendar.routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';

import campaignsRoutes from './campaigns/campaigns.routes';
import activeMessagesRoutes from './active_messages/active_messages.routes';
import helpcenterViewerRoutes from './helpcenter_viewer/helpcenter_viewer.routes';
import { routes as ticketsRoutes } from './tickets/routes';
import { routes as lumeraiRoutes } from './lumerai/lumerai.routes';
import { routes as alertsRoutes } from './alerts/routes';
import { routes as smsRoutes } from './sms/sms.routes';
import { routes as voiceRoutes } from './voice/voice.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...alertsRoutes,
        ...lumeraiRoutes,
        ...inboxRoutes,
        ...voiceRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...salesPipelineRoutes,
        ...calendar.routes,
        ...searchRoutes,
        ...notificationRoutes,

        ...activeMessagesRoutes.routes,
        ...campaignsRoutes.routes,
        ...smsRoutes,
        ...ticketsRoutes,
        ...helpcenterViewerRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
